import {
  BASE_X_SMALL_SIZE,
  BASE_SMALL_SIZE,
  BASE_MEDIUM_SIZE,
  BASE_LARGE_SIZE,
  BASE_X_LARGE_SIZE,
} from 'gatsby-theme-marketplace-base/src/layout/media-queries'

export const AA_SIDEBAR_WIDTH = 0
const X_SMALL_SIZE = BASE_X_SMALL_SIZE
const SMALL_SIZE = BASE_SMALL_SIZE + AA_SIDEBAR_WIDTH
const MEDIUM_SIZE = BASE_MEDIUM_SIZE + AA_SIDEBAR_WIDTH
const LARGE_SIZE = BASE_LARGE_SIZE + AA_SIDEBAR_WIDTH
const XLARGE_SIZE = BASE_X_LARGE_SIZE + AA_SIDEBAR_WIDTH

export default {
  BASE_X_SMALL_SIZE: X_SMALL_SIZE,
  BASE_SMALL_SIZE: SMALL_SIZE,
  BASE_MEDIUM_SIZE: MEDIUM_SIZE,
  BASE_LARGE_SIZE: LARGE_SIZE,
  BASE_X_LARGE_SIZE: XLARGE_SIZE,
  X_SMALL: `${X_SMALL_SIZE}px`,
  SMALL: `${SMALL_SIZE}px`,
  MEDIUM: `${MEDIUM_SIZE}px`,
  LARGE: `${LARGE_SIZE}px`,
  xsmallScreen: (offset = 0) =>
    `@media (min-width: ${BASE_X_SMALL_SIZE + offset}px)`,
  smallScreen: (offset = 0) => `@media (min-width: ${SMALL_SIZE + offset}px)`,
  mediumScreen: (offset = 0) => `@media (min-width: ${MEDIUM_SIZE + offset}px)`,
  largeScreen: (offset = 0) => `@media (min-width: ${LARGE_SIZE + offset}px)`,
  xlargeScreen: (offset = 0) => `@media (min-width: ${XLARGE_SIZE + offset}px)`,
}
